import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Col, Divider, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import { getConfigurationMessages, getErrorMessages, getFields, getModalMessages } from '../constants/messages';
import LanguageControl from './LanguageControl';

let configurationMessages = getConfigurationMessages(),
	errorMessages = getErrorMessages(),
	fields = getFields(),
	modalMessages = getModalMessages();

const messages = {
	...modalMessages,
	...errorMessages,
	...configurationMessages,
	...fields,
};

const MapConfig = ({ loading }) => {
	return (
		<Row className="">
			<Spin spinning={loading}>
				<Divider>
					<FormattedMessage {...messages.controls} />
				</Divider>
				<Col span={24}>
					<FormattedMessage {...messages.languages} />
				</Col>
				<Col span={24}>
					<LanguageControl size="small" />
				</Col>
			</Spin>
		</Row>
	);
};

MapConfig.propTypes = {
	loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
	return {
		loading: state.configuration.loading,
	};
};

export default connect(mapStateToProps)(MapConfig);
